import * as React from "react";

import { Move, Video } from "../../types";
import { Space, TextInput } from "../../styled-component";
import CRUDModal, { CRUDModalProps } from "../../common/components/CRUDModal";
import MoveService from "../../services/Move";

import Button from "../common/PressableButton";
import Text from "../common/Text";
import VideoComponents from "../video";

const DEFAULT_VALUES = { name: "", videos: [] };

export type CreateOrUpdateMoveProps = Omit<CRUDModalProps<Move>, "service">;

const service = new MoveService();

function CreateOrUpdateMove(rest: CreateOrUpdateMoveProps) {
  const getButtonTitle: CRUDModalProps<Move>["getButtonTitle"] = (
    _move,
    { isNew } = {}
  ) => (isNew ? "Create Move" : "Edit Move");

  const getModalTitle: CRUDModalProps<Move>["getModalTitle"] = (
    move,
    { isNew } = {}
  ) => (isNew ? "New Move" : move?.name || "|");

  const getDefaultValues: CRUDModalProps<Move>["getDefaultValues"] = (move) => {
    const defaultValues = move
      ? { ...move, videos: move?.videos?.map((video) => video.id) }
      : DEFAULT_VALUES;

    return defaultValues;
  };

  return (
    <CRUDModal<Move>
      {...rest}
      getButtonTitle={getButtonTitle}
      getModalTitle={getModalTitle}
      getDefaultValues={getDefaultValues}
      service={service}
      renderForm={({ setValue, watch, isNew, isDisabled }) => {
        const name = watch("name");
        const videos = watch("videos") as Video["id"][];

        return (
          <>
            <Text.Label>Name</Text.Label>
            <TextInput
              editable={!isDisabled}
              onChangeText={(nextName) => setValue("name", nextName)}
              placeholder="Left turn"
              autoFocus={isNew}
              value={name}
            />

            <Space />

            <Text.Label>Videos</Text.Label>
            {videos.map((videoId, index) => (
              <React.Fragment key={["video", videoId].join("-")}>
                {index > 0 && <Space />}

                <VideoComponents.Input
                  key={`video-${index}`}
                  value={videoId}
                  onChange={(nextVideoId) =>
                    setValue(`videos.${index}`, nextVideoId)
                  }
                />
              </React.Fragment>
            ))}

            <Space />

            <Button
              title="Add Video"
              onPress={() => setValue("videos", [...videos, undefined])}
              disabled={isDisabled}
              mode="outlined"
            />
          </>
        );
      }}
    />
  );
}

export default CreateOrUpdateMove;
